import { t } from '@lingui/core/macro'

import type { BrandThemeIcon } from '@jotta/types/Brand'
import type { FileRouteContext } from '@jotta/types/schemas/FileRouteSchema'
import SvgArchive from '@jotta/ui/SvgArchive'
import SvgBackup from '@jotta/ui/SvgBackup'
import SvgCaretLeft from '@jotta/ui/SvgCaretLeft'
import SvgPhotos from '@jotta/ui/SvgPhotos'
import SvgSync from '@jotta/ui/SvgSync'
import SvgTrash from '@jotta/ui/SvgTrash'
import SvgUsersShared from '@jotta/ui/SvgUsersShared'
import SvgWifiHigh from '@jotta/ui/SvgWifiHigh'

const moduleNav: readonly FileRouteContext[] = [
  'sync',
  'backup',
  'archive',
  'shared',
] as const

export type FileRouteContextConfig = {
  apiPath: string
  to: string
  icon: BrandThemeIcon
  text: string
  rootContext?: FileRouteContext
  moduleNav: readonly FileRouteContext[]
}

export type FileRouteContextConfigMap = Record<
  FileRouteContext,
  FileRouteContextConfig
>

export const fileRouteContextConfig: FileRouteContextConfigMap = {
  sync: {
    to: '/web/sync/list/name',
    apiPath: '/sync',
    moduleNav,
    get text() {
      return t`Sync`
    },
    icon: SvgSync,
  },
  backup: {
    to: '/web/backup/list/name',
    apiPath: '/backup',
    moduleNav,
    get text() {
      return t`Backup`
    },
    icon: SvgBackup,
  },
  archive: {
    to: '/web/archive/list/name',
    apiPath: '/archive',
    moduleNav,
    get text() {
      return t`Archive`
    },
    icon: SvgArchive,
  },
  shared: {
    to: '/web/shared/list/name',
    apiPath: '/shared',
    moduleNav,
    get text() {
      return t`Shared Files`
    },
    icon: SvgUsersShared,
  },
  search: {
    to: '/web/search/list/name',
    apiPath: '/search',
    moduleNav: ['search'] as const,
    get text() {
      return t`Search:`
    },
    icon: SvgCaretLeft,
  },
  photos: {
    to: '/web/photos/list/name',
    apiPath: '/photos',
    moduleNav: ['photos'] as const,
    get text() {
      return t`Photo Timeline Uploads`
    },
    icon: SvgPhotos,
    rootContext: 'backup',
  },
  contacts: {
    to: '/web/contacts/list/name',
    apiPath: '/contacts',
    moduleNav: ['contacts'] as const,
    get text() {
      return t`Contacts`
    },
    icon: SvgWifiHigh,
    rootContext: 'backup',
  },
  trash: {
    to: '/web/trash',
    apiPath: '/trash',
    moduleNav: ['trash'] as const,
    get text() {
      return t`Trash`
    },
    icon: SvgTrash,
  },
}
